import PubSub from 'pubsub-js';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';

const header = {
  $header: document.getElementById('main_header'),
  init() {
    console.log('Header init');

    this.setUpListeners();
    setTimeout(this.setVariables.bind(this), 10);
    setTimeout(this.preparePageForAnimations.bind(this), 20);
  },

  setUpListeners() {
    const $menuArea = this.$header.querySelector('.menu_area');

    PubSub.subscribe(
      'header.updateMenuItems',
      this.updateMenuItems.bind(this)
    );

    PubSub.subscribe(
      'header.toggleColor',
      this.toggleColor.bind(this)
    );

    this.$header
      .querySelector('.mobile_toggler')
      .addEventListener('click', () => {
        $menuArea.classList.add('active');
      });

    this.$header
      .querySelector('.mobile_close')
      .addEventListener('click', () => {
        $menuArea.classList.remove('active');
      });

    this.$header
      .querySelectorAll('.menu-item > a')
      .forEach($menuItem => {
        $menuItem
          .addEventListener('click', () => {
            $menuArea.classList.remove('active');
          });
      });

    PubSub.subscribe(
      'page.inDOM',
      () => {
        setTimeout(this.setVariables.bind(this), 10);
        setTimeout(this.preparePageForAnimations.bind(this), 20);
        setTimeout(this.animatePageIn.bind(this), 30);
      }
    );

    PubSub.subscribe(
      'page.splashDone',
      () => {
        setTimeout(this.setVariables.bind(this), 10);
        setTimeout(this.preparePageForAnimations.bind(this), 20);
        setTimeout(this.animatePageIn.bind(this), 30);
      }
    );
  },

  setVariables() {
    this.$logo = this.$header.querySelector('.logo_wrapper');
    this.$menuItems = this.$header.querySelectorAll('.menu > .menu-item');
    this.$mobileToggler = this.$header.querySelectorAll('.mobile_toggler');
    this.$quickMenuItems = document.querySelectorAll('#quick_nav > button');
    this.$firstParagraph = document.querySelector(
      'section.section_module:first-child .content'
    );
    this.$fixedBg = document.querySelector('.fixed_bg');
  },

  preparePageForAnimations() {
    const $textBlocks = this.$firstParagraph.querySelectorAll(
      'h2, h3, p, .ctas_wrapper'
    );

    if (this.tl && this.tl.isActive()) {
      this.tl.kill();
      console.log('Killing');
    }

    gsap.set(this.$logo, {
      opacity: 0
    });

    gsap.set(this.$menuItems, {
      opacity: 0,
      x: '3vw'
    });

    gsap.set(this.$mobileToggler, {
      opacity: 0
    });

    gsap.set(this.$quickMenuItems, {
      y: window.innerWidth > 767 ? '2vw' : '7vw',
      rotateX: '-40deg',
      opacity: 0
    });

    gsap.set($textBlocks, {
      y: window.innerWidth > 767 ? '5vw' : '15vw',
      rotateX: '-40deg',
      opacity: 0
    });

    gsap.set(this.$fixedBg, {
      scale: 1.1,
      opacity: 1.1
    });
  },

  animatePageIn() {
    this.tl = gsap.timeline({});
    const $textBlocks = this.$firstParagraph.querySelectorAll(
      'h2, h3, p, .ctas_wrapper'
    );
    const dur = 2;

    this.tl.to(this.$logo, {
      opacity: 1,
      duration: dur * 1.5
    });

    this.tl.to(this.$menuItems, {
      opacity: 1,
      stagger: .08,
      x: 0,
      duration: dur * 0.4
    }, dur * 0.1);

    this.tl.to(this.$mobileToggler, {
      opacity: 1,
      duration: dur * 0.3
    }, dur * 0.2);

    this.tl.to($textBlocks, {
      y: '0vw',
      rotateX: 0,
      opacity: 1,
      duration: dur / 2,
      stagger: .13,
      ease: 'power3.out',
      delay: .2
    }, dur * 0.3);

    this.tl.to(this.$quickMenuItems, {
      y: '0vw',
      rotateX: 0,
      opacity: 1,
      stagger: .13
    }, dur * 0.4);

    this.tl.to(this.$fixedBg, {
      scale: 1,
      opacity: 1,
      duration: dur
    }, dur * 0.01);
  },

  updateMenuItems(ev, $newHeader) {
    const $currMenuItems = this.$header.querySelectorAll('.menu-item');

    $newHeader
      .querySelectorAll('.menu-item')
      .forEach(($el, id) => {
        $currMenuItems[id]
          .setAttribute(
            'class',
            $el.getAttribute('class')
          );
      });
  },

  toggleColor(ev, bgColor) {
    if (bgColor === 'FFFFFF' && !this.$header.classList.contains('dark')) {
      this.$header.classList.add('dark');
    } else if (bgColor !== 'FFFFFF'
      && this.$header.classList.contains('dark')) {
      this.$header.classList.remove('dark');
    }
  }
};


export default header;
